import React, { useState } from 'react';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { useGetProjectQuery } from '../../features/api/apiSlice';
import ProjectCardLoader from '../ui/Loaders/ProjectCardLoader';

const ProjectViewPoup = ({ descriptionId }) => {


    const [modal, setModal] = React.useState(true);

    let content = null;
    const { data: project, isLoading, isError, isSuccess } = useGetProjectQuery(descriptionId, {
        skip: modal
    });

    const [showMore, setShowMore] = useState(1);


    const [foldedLines, setFoldedLines] = useState([]);
    const handleLineFold = (lineIndex) => {
        if (foldedLines.includes(lineIndex)) {
            setFoldedLines(foldedLines.filter((index) => index !== lineIndex));
        } else {
            setFoldedLines([...foldedLines, lineIndex]);
        }
    };

    if (isLoading) {
        console.log("4", project)
        content = (
            <div className="">
                <ProjectCardLoader />
            </div>
        )
    }
    if (!isLoading && isError) {
        console.log("3", project)
        content = (
            <div className="">
                <p className="text-gray-700 dark:text-gray-400">
                    Something went wrong.
                </p>
            </div>
        )
    }
    if (!isLoading && !isError && [project]?.length === 0) {
        console.log("2", project)
        content = (
            <p className="text-gray-700 dark:text-gray-400">
                No data found
            </p>
        )
    }
    if (!isLoading && !isError && project?.title) {
        console.log("1", project)
        content = (
            <div className="">
                <div className=''>
                    {
                        project.photos.map((item, index) => (
                            <div key={index} className="w-full mb-5">
                                <img className="full h-full object-cover object-center" src={item.photo} alt="" />
                            </div>
                        ))
                    }
                </div>
                <div className="pt-7">

                    <h5 className="text-gray-800 font-medium">Skills and deliverables</h5>
                    <div className="pt-2">
                        {
                            project?.skills.map((skill, index) => (
                                <button key={index} className="m-1 bg-primary bg-opacity-20 text-gray-800 px-3 py-0.5 rounded-3xl text-sm">{skill}</button>
                            ))
                        }
                    </div>
                </div>

                <div className="pt-7">

                    <h5 className="text-gray-800 font-medium">Project Description</h5>
                    <ul>
                        {project?.description.slice(0, showMore).map((line, index) => (
                            <li
                                key={index}
                                className={`${foldedLines.includes(index) ? 'folded' : ''} text-sm font-inter text-gray-700`}
                                onClick={() => handleLineFold(index)}
                                style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} // Enable word wrapping
                            >
                                {line || '\u00A0'}

                            </li>
                        ))}
                        {showMore === 1 ?
                            <span className='text-primary font-semibold cursor-pointer' onClick={() => setShowMore(project.description.length)}> showMore</span>

                            :
                            <span className='text-primary font-semibold cursor-pointer' onClick={() => setShowMore(1)}> showLess</span>
                        }
                    </ul>
                </div>

                <div className='pt-7'>
                    <a href={project?.projectUrl} target="_blank" className=" text-primary font-sans">{project?.projectUrl}</a>
                </div>
            </div>
        )
    }


    return (
        <div className="w-full h-full">
            <div className='absolute hidden group-hover:block  top-0 left-0 w-full h-full bg-slate-900 bg-opacity-70'>
                <div className='flex items-center justify-center h-full'>
                    {/* // <!-- Modal toggle --> */}
                    <button onClick={() => setModal(!modal)} className="flex mt-2 gap-3 items-center border-2 border-primary px-5 py-1.5 rounded-full font-semibold text-primary" type="button">
                        <HiOutlineExternalLink className="" />  view details
                    </button>

                </div>
            </div>

            {/* // <!-- Main modal --> */}
            <div className={`fixed flex justify-center top-0 left-0 right-0 z-50 ${modal ? "hidden" : 'block'} w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full bg-gray-800 bg-opacity-50`}>
                <div className="relative w-full max-w-3xl max-h-full">
                    {/* <!-- Modal content --> */}
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        {/* <!-- Modal header --> */}
                        <div className="flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600">
                            <h3 className="text-2xl font-inter font-medium text-gray-900 dark:text-white">
                                {project?.title}
                            </h3>
                            <button onClick={() => setModal(!modal)} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="staticModal">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </button>
                        </div>
                        {/* <!-- Modal body --> */}
                        <div className="p-6 space-y-6">
                            {content}
                            {/* {project.photos.map()} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectViewPoup;